module.exports = __webpack_public_path__ + "67f50b5e7eb9a9599be8bbce742b559f.svg";